module.exports = "/images/SetUpYourCompany-3.jpg";